import React from 'react';
import { Container, Period, ModifiedInput } from './styles';
import NumericInput from 'react-numeric-input';

export const TimePicker = ({
  hour,
  changeHour,
  minute,
  changeMinute,
  period,
  setPeriod,
}) => {
  return (
    <>
      <Container>
        <div className='numberInputs'>
          <ModifiedInput>
            <NumericInput
              mobile={true}
              onChange={(valueAsNumber) => changeHour(valueAsNumber)}
              min={1}
              max={12}
              value={hour}
            />
          </ModifiedInput>
          <span
            className='separator'
            style={{
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              margin: '0 5px',
            }}
          >
            :
          </span>
          <ModifiedInput>
            <NumericInput
              mobile={true}
              onChange={(valueAsNumber) => changeMinute(valueAsNumber)}
              min={0}
              max={59}
              value={minute}
            />
          </ModifiedInput>
        </div>
        <Period period={period} style={{ marginLeft: '8px' }}>
          <div>
            <div className='period_option' onClick={() => setPeriod('AM')}>
              AM
            </div>
            <div className='period_option' onClick={() => setPeriod('PM')}>
              PM
            </div>
            <div className='period_bg'></div>
          </div>
        </Period>
      </Container>
    </>
  );
};
